<template>
  <div id="layout-footer">
    <div class="footer-main">
      <div class="footer-item">
        <div class="footer-item-title">相关链接</div>
        <div><a target="_blank" class="out-link" :href="this.$store.state.authConfig.github">
          <i class="iconfont icon-github"></i>github</a>
        </div>
        <div><a target="_blank" class="out-link" :href="this.$store.state.authConfig.gitee">
          <i class="iconfont icon-gitee"></i>gitee</a>
        </div>
      </div>
      <div class="footer-item">
        <div>本站已运行 {{ this.$store.state.runTimeInterval }}</div>
        <div>在线人数<em style="background: linear-gradient(0deg,#367eda,#964fdb);font-size: 12px;padding: 0 15px">{{ this.$store.state.onlinePerson }}</em></div>
        <div><a target="_blank" class="out-link" :href="this.$store.state.webConfig.managementUrl">☞后台管理</a></div>
      </div>
    </div>
    <div class="copyright">
      Copyright © {{ this.$store.state.runTimeYear }} by
      <a target="_blank" class="out-link" :href="this.$store.state.webConfig.webUrl">qiangesoft.cn</a>
      . All rights reserved. |
      <a target="_blank" class="out-link" href="https://beian.miit.gov.cn/">{{
          this.$store.state.webConfig.recordNum
        }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "layout-footer",
  data() {
    return {

    }
  },
  computed: {
  },
  methods: {},
  created() {
  }
}
</script>

<style scoped lang="less">
#layout-footer {
  padding: 1%;
  border-top: 1px solid #F7F7F7;
  font-size: 13px;
  color: #F7F7F7;
  background-color: #263547;
}

a {
  text-decoration: none;
  color: #F7F7F7;
}

.out-link:hover {
  color: antiquewhite;
}

.footer-main {
  max-width: 800px;
  margin: 0 auto 20px auto;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
}
.footer-item-title{
  font-size:17px;
  font-weight: bold;
}

.footer-item div {
  margin-top: 10px;
}

.copyright {
  text-align: center;
}
</style>
